<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>Explore, Learn, and Grow with ARNI</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Blog</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<div class="container my-5">
    <div class="row g-4">
        <div class="col-12 col-md-4" *ngFor="let blog of blogs">
            <div class="card card-custom card-image hover-effect " style="cursor: pointer;"
                 (click)="saveAtLocal('blog-details', blog?.url)"
                 [ngStyle]="{ 'background-image': 'url(' + blog?.blog_cover?.url + ')' }">
                <div class="card-body">
                    <h5 class="card-title"
                        (click)="saveAtLocal('blog-details', blog?.url)">{{ blog.heading }}</h5>
                </div>
            </div>
        </div>
    </div>
</div>


